import { useCallback, useState } from 'react'
import { usePagination } from '@yes.technology/react-toolkit'

import api from '../../../utils/api'
import {
  fetchFilteraction,
  resolveQuery
} from '../../imported/FilteractionResolver'

export const INITIAL_PAGINATION = { limit: 10, offset: 0 }

export const INITIAL_SORT_OPTIONS = [
  {
    date_creation_row: 'desc'
  }
]

export default function useFetchYesObjects({
  initialPagination = INITIAL_PAGINATION,
  initialSortOptions = INITIAL_SORT_OPTIONS
} = {}) {
  const [yesObjects, setYesObjects] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const { pagination, setPage } = usePagination({ initialPagination })
  const [totalObjects, setTotalObjects] = useState(0)

  const [sortOptions, setSortOptions] = useState(initialSortOptions)

  const performFetch = useCallback(
    async ({ filterBody, showLoading, pathTemp }) => {
      setIsLoading(true)

      try {
        const fetchResponse = await api.postObjectsFilter({
          objectclass: filterBody.objectclass,
          orderby: filterBody.orderby,
          pagination: filterBody.pagination,
          query: filterBody.query,
          showLoading,
          path: pathTemp
        })

        setYesObjects(fetchResponse?.data?.objects || [])
        setTotalObjects(fetchResponse?.data?.pagination?.total || 0)

        setIsLoading(false)
        return fetchResponse.objects || []
      } catch (error) {
        console.log(error?.message)
      }

      setIsLoading(false)
      return []
    },
    []
  )

  const performFetchFilteraction = useCallback(
    async ({ filteractionUuid, filterBody, showLoading }) => {
      setIsLoading(true)

      const onProgressCallback = (message) => {
        console.log(message)
      }

      try {
        const filteraction = await fetchFilteraction(
          filteractionUuid,
          showLoading
        )

        const filteractionQuery =
          filteraction?.query && JSON.parse(filteraction?.query)

        const filteractionObjectclassUuid =
          filteraction?.filter_action_objectclass?.[0]?.uuid

        const filteractionResolvedQuery = await resolveQuery(
          filteractionQuery,
          onProgressCallback,
          [filteractionUuid],
          showLoading
        )

        const query = {
          $and: [filteractionResolvedQuery]
        }

        const fetchResponse = await api.postObjectsFilter({
          filterBody: {
            query,
            objectclass: filteractionObjectclassUuid,
            pagination: filterBody.pagination,
            orderby: filterBody.orderby
          },
          showLoading
        })

        setYesObjects(fetchResponse?.objects || [])
        setTotalObjects(fetchResponse?.pagination?.total || 0)

        setIsLoading(false)
        return fetchResponse?.objects || []
      } catch (error) {
        console.log(error?.message)
      }

      setIsLoading(false)
      return []
    },
    []
  )

  return {
    yesObjects,
    isLoading,
    fetchYesObjects: performFetch,
    fetchYesObjectsWithFilteraction: performFetchFilteraction,
    pagination,
    totalObjects,
    setPage,
    sortOptions,
    setSortOptions
  }
}
